import apiClient from "@/services/apiClient";

const downloadResponse = (response, fallbackName) => {
  const disposition = response.headers?.["content-disposition"] || "";
  const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plainName = disposition.match(/filename="?([^";]+)"?/i)?.[1];
  const fileName = encodedName ? decodeURIComponent(encodedName) : plainName || fallbackName;
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const exportGrid = async (format, payload) => {
  const response = await apiClient.post(`/AdminGridExport/${format}`, payload, { responseType: "blob" });
  downloadResponse(response, `${payload.title || "grid-export"}.${format === "excel" ? "xlsx" : "pdf"}`);
};

export const gridExportService = {
  exportExcel: (payload) => exportGrid("excel", payload),
  exportPdf: (payload) => exportGrid("pdf", payload),
};
